import { render, staticRenderFns } from "./PushSwitch.vue?vue&type=template&id=32312402&"
import script from "./PushSwitch.vue?vue&type=script&lang=js&"
export * from "./PushSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PushSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports